import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { ComponentStyle } from '../../types/types';

import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

const BackgroundPatternContainer = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  // z-index is -1 here to ensure the pattern is behind the title and description
  zIndex: -1,
});

const BackgroundPatternSvg = styled.svg<{ color?: string; opacity?: number }>(props => ({
  color: props.color ?? 'var(--color-dark)',
  position: 'absolute',
  left: '35%',
  top: pxToRem(176),
  opacity: props.opacity ?? 0.5,
  transform: 'translate(-50%, -50%) rotate(-130deg) scale(1.3)',
  width: pxToRem(280),
  height: pxToRem(1400),

  [mqBreakpoints.tablet]: {
    left: '19.5%',
    top: pxToRem(208),
    width: pxToRem(320),
    height: pxToRem(1600),
  },

  [mqBreakpoints.desktop]: {
    left: '19.5%',
    top: pxToRem(400),
    width: pxToRem(800),
    height: pxToRem(2560),
  },
}));

type Props = {
  style: ComponentStyle;
};

export const HeaderBackgroundPattern: React.FC<Props> = ({ style }) => {
  return (
    <>
      <BackgroundPatternContainer>
        <BackgroundPatternSvg data-src={`${Config.get('image_cdn_base_url')}/ui/product-marketplace-webapp/vertical-pattern.svg`} color={style !== ComponentStyle.B ? 'var(--color-secondary-2)' : 'var(--color-dark)'} />
      </BackgroundPatternContainer>
      {/* Second pattern overlaps content below due to increased height. It will only work well against light background colours. */}
      <BackgroundPatternContainer style={{ height: pxToRem(1200) }}>
        <BackgroundPatternSvg data-src={`${Config.get('image_cdn_base_url')}/ui/product-marketplace-webapp/vertical-pattern.svg`} opacity={0.05} />
      </BackgroundPatternContainer>
    </>
  );
};
